define('app',[
    // services
    'services/ajax-config',
    'services/activity-watcher',
    'services/user',
    'services/i18n',
    'services/events/user-events',
    'services/notifications/new-message-received',
    'services/toastr-service',
    'services/firebase.service',
    'services/layout',
    // Libs
    "backbone", "utils",
    // our code
    "router",
    "datepicker",
    "debug",
], function (AjaxConfig, ActivityWatcher, User, i18n, UserEvents, NewMessageReceived, ToastrService, FirebaseService, LayoutState, Backbone, U, AppRouter) {

    i18n.setLanguage(U.getSavedLanguage(), true);

    AjaxConfig.setBeforeSendAjaxConfig().setAjaxErrorConfig();

    if (U.getCookieByName('fbTokenTC')) {
        // Record activity if the user is already logged in
        ActivityWatcher.start();
    }

    if (window.location.href.includes('messages')) {
        window.location.href = "#";
    }

    if (window.location.href.includes('garmin_oauth_success')) {
        window.setTimeout(function() {
            ToastrService.success('connection-successful');
        }, 2000);
    }

    var r = new AppRouter();
    Backbone.history.start();

    Backbone.history.on('route', function () {
        U.showIntercom();
        UserEvents.refreshCompletedTutorialsCount();
        if (
            Backbone.history.getFragment().includes('messages') ||
            Backbone.history.getFragment().includes('notes') ||
            Backbone.history.getFragment().includes('template') ||
            Backbone.history.getFragment().includes('animated')
        ) {
            U.hideIntercom();
        }
    });

    if ('PushManager' in window) {
        var messaging = firebase.messaging();

        messaging.onMessage(function (payload) {
            if(payload.data.type === "NewMessageReceived" && ! Backbone.history.getFragment().includes(payload.data.conversationId)) {
                // Display a notification unless we're on the conversation interface
                var options = {
                    progressBar: true,
                    onclick: function() {
                        Backbone.history.redirect(payload.data.url); // Redirect to the conversation
                    }
                };
                ToastrService.notify(payload.data.title, payload.data.body, options);
            }
        });
    }

    // DISABLE StatusBar plugin calls - they keep resetting colors to TRANSPARENT (#00000000)
    // The native MainActivity.java will handle all system bar colors and appearance
    // The StatusBar plugin's setOverlaysWebView({ overlay: false }) causes the bars
    // to become transparent, which makes white WebView content show through
    // Note: theme-color meta tags have been removed from HTML files to prevent conflicts
    console.log('[SystemBars] StatusBar plugin calls DISABLED - native MainActivity handles everything');

    // Handle Android back button with Capacitor App plugin
    // Set up immediately and also on deviceready
    var lastBackButtonTime = 0;
    var BACK_BUTTON_DEBOUNCE_MS = 300; // Prevent double-firing within 300ms
    
    function setupBackButtonListener() {
        if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.App) {
            var App = window.Capacitor.Plugins.App;
            
            App.addListener('backButton', function(data) {
                var now = Date.now();
                // Debounce: ignore if fired too quickly after last press (likely double-fire)
                if (now - lastBackButtonTime < BACK_BUTTON_DEBOUNCE_MS) {
                    lastBackButtonTime = now;
                    return;
                }
                lastBackButtonTime = now;
                
                // Priority 1: Close menu drawer if open (check DOM directly)
                var $drawer = Backbone.$('#menu-drawer');
                if ($drawer.length && $drawer.hasClass('open')) {
                    $drawer.removeClass('open');
                    LayoutState.setState('menu.drawer', false);
                    return;
                }
                
                // Priority 2: Close left side menu if expanded (check DOM directly)
                // The menu structure is: #menu > .overlay (the .overlay gets the 'open' class)
                var $menu = Backbone.$('#menu');
                var $menuOverlay = $menu.find('.overlay').first();
                var isMenuOpen = $menuOverlay.length && $menuOverlay.hasClass('open');
                if (isMenuOpen) {
                    // Use LayoutState.toggleMenu which triggers the event that the menu listens to
                    // The menu's onToggleMenu handler will properly close it
                    LayoutState.toggleMenu(false);
                    // Also directly manipulate DOM as backup
                    // Use setTimeout to ensure event fires first, then DOM manipulation as fallback
                    setTimeout(function() {
                        if ($menuOverlay.hasClass('open')) {
                            $menuOverlay.removeClass('open');
                            LayoutState.setState('menu', false);
                        }
                    }, 50);
                    return;
                }
                
                // Priority 3: Navigate back in history if possible
                var fragment = Backbone.history.getFragment();
                
                // Check if we're at the main dashboard/calendar page
                // Main page patterns: 
                // - supervisor/group/default/member/me/calendar/ (main calendar view - NO sub-routes)
                // - supervisor/group/default/member/me/dashboard/ (main dashboard view - NO sub-routes)
                // - supervisor/ (supervisor root)
                // We're at main page if we're on calendar/dashboard but NOT on a sub-route like /goal/, /message/, /template/, etc.
                var match1 = fragment.match(/^supervisor\/group\/[^\/]+\/member\/[^\/]+\/(calendar|dashboard)\/?$/);
                var match2 = fragment.match(/^group\/[^\/]+\/member\/[^\/]+\/(calendar|dashboard)\/?$/);
                
                // Check if we're on a sub-route (not main page)
                var isSubRoute = fragment.includes('/goal/') || 
                                 fragment.includes('/message/') || 
                                 fragment.includes('/template/') ||
                                 fragment.includes('/activity/') ||
                                 fragment.includes('/animated/') ||
                                 fragment.includes('/nutrilog/') ||
                                 fragment.includes('/custom_data/') ||
                                 fragment.includes('/questionnaire/');
                
                var isAtMainPage = (!fragment || 
                                   fragment === '' || 
                                   fragment === '/' ||
                                   fragment === 'supervisor' ||
                                   fragment === 'supervisor/') ||
                                   (!!match1 && !isSubRoute) ||
                                   (!!match2 && !isSubRoute);
                
                if (!isAtMainPage) {
                    // Try to navigate back using browser history
                    if (window.history.length > 1) {
                        window.history.back();
                    } else {
                        // Fallback: navigate to dashboard
                        var currentFragment = Backbone.history.getFragment();
                        if (currentFragment.includes('group/') && currentFragment.includes('member/')) {
                            var parts = currentFragment.split('/');
                            var groupIdx = parts.indexOf('group');
                            var memberIdx = parts.indexOf('member');
                            if (groupIdx >= 0 && memberIdx >= 0 && memberIdx < parts.length - 1) {
                                var groupId = parts[groupIdx + 1];
                                var userId = parts[memberIdx + 1];
                                Backbone.history.navigate('group/' + groupId + '/member/' + userId + '/dashboard/', { trigger: true });
                            }
                        }
                    }
                    return;
                }
                
                // Priority 4: Minimize app and return to home screen (when at main page)
                // Use minimizeApp() instead of exitApp() to minimize without exiting
                // This keeps the app in memory for instant resume
                if (window.Capacitor && window.Capacitor.getPlatform() === 'android') {
                    // Use minimizeApp() which minimizes without exiting (faster resume)
                    // Available in Capacitor 1.1.0+ for Android
                    if (App.minimizeApp) {
                        App.minimizeApp().catch(function(error) {
                            // Fallback: if minimizeApp fails, use exitApp
                            App.exitApp().catch(function() {});
                        });
                    } else {
                        // Fallback: if minimizeApp not available, use exitApp
                        App.exitApp().catch(function() {});
                    }
                } else {
                    // For other platforms, use exitApp
                    App.exitApp().catch(function(error) {
                        // Error handling
                    });
                }
            });
        }
    }
    
    // Try to set up immediately
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupBackButtonListener);
    } else {
        setupBackButtonListener();
    }
    
    // Also try on deviceready in case Capacitor loads later
    document.addEventListener("deviceready", function () {
        console.log('deviceready fired');
        // Use Capacitor Firebase service for push notifications
        FirebaseService.onMessageReceived(function (notification) {
            switch (notification.type) {
                case 'NewMessageReceived':
                    (new NewMessageReceived).handle(notification);
                    break;
            }
        }, function (error) {
            console.error('Firebase push notification error:', error);
        });
        
        // Try setting up back button listener again
        setupBackButtonListener();
    }, false);

});

